var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyCasino = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 216,
  height: 97
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#161623",
  d: "M119 0a7 7 0 1 1 0 14h64a7 7 0 1 1 0 14h22a7 7 0 1 1 0 14h-19a7 7 0 1 0 0 14h6a7 7 0 1 1 0 14h-52a7 7 0 0 1-1.5-.161A7 7 0 0 1 137 70H46a7 7 0 1 1 0-14H7a7 7 0 1 1 0-14h40a7 7 0 1 0 0-14H22a7 7 0 1 1 0-14h40a7 7 0 1 1 0-14zm90 56a7 7 0 1 1 0 14 7 7 0 0 1 0-14"
}), /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 2,
  x: 51,
  y: 81,
  fill: "#3B3950",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 2,
  x: 36,
  y: 81,
  fill: "#3B3950",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 74,
  height: 80,
  x: 76,
  y: 15,
  fill: "#1D1C2C",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232134",
  d: "M86 28h55v30H86z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#413F55",
  fillRule: "nonzero",
  d: "M137 26.75H90A5.25 5.25 0 0 0 84.75 32v22c0 2.9 2.35 5.25 5.25 5.25h47c2.9 0 5.25-2.35 5.25-5.25V32c0-2.9-2.35-5.25-5.25-5.25m-47 2.5h47a2.75 2.75 0 0 1 2.75 2.75v22a2.75 2.75 0 0 1-2.75 2.75H90A2.75 2.75 0 0 1 87.25 54V32A2.75 2.75 0 0 1 90 29.25"
}), /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 2,
  x: 95,
  y: 82,
  fill: "#3B3950",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#373849",
  fillRule: "nonzero",
  d: "M147.814 15c1.702 0 3.087 1.368 3.181 3.085l.005.185v73.448c0 2.841-2.184 5.163-4.926 5.278l-.212.004H80.138c-2.77 0-5.023-2.251-5.134-5.065L75 91.718V72.6c0-.694.552-1.257 1.234-1.257.639 0 1.164.494 1.227 1.129l.007.128v19.117c0 1.474 1.111 2.675 2.507 2.762l.163.005h65.724c1.417 0 2.581-1.146 2.665-2.598l.005-.17V18.27a.744.744 0 0 0-.621-.748l-.097-.007H79.232c-.93 0-1.685.715-1.758 1.617l-.006.144v40.462c0 .694-.553 1.257-1.234 1.257a1.244 1.244 0 0 1-1.228-1.129L75 59.738V19.276c0-2.295 1.788-4.163 4.027-4.271l.205-.005zM76.25 63c.647 0 1.18.492 1.244 1.122l.006.127v4.502a1.25 1.25 0 0 1-2.494.127L75 68.751v-4.502c0-.69.56-1.249 1.25-1.249"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#413F55",
  fillRule: "nonzero",
  d: "m95.127 49 2.64-10.425V36.85h-5.76v1.905h3.316L92.683 49zm17 0 2.64-10.425V36.85h-5.76v1.905h3.316L109.683 49zm17 0 2.641-10.425V36.85h-5.761v1.905h3.315L126.683 49z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 2,
  x: 155,
  y: 81,
  fill: "#3B3950",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 2,
  x: 182,
  y: 81,
  fill: "#3B3950",
  rx: 1
}))));
export { SvgEmptyCasino as ReactComponent };
export default __webpack_public_path__ + "../icons/2563cb5273804266ac86b0d2202c6d0f.svg";